import React from "react";
import Modal from "@mui/material/Modal";

const EmailModal = ({ open, handleClose, children }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div className="email-modal">
        {children}
      </div>
    </Modal>
  );
};

export default EmailModal;
